import {Component, OnInit, Input, NgModule, NO_ERRORS_SCHEMA, AfterViewInit} from '@angular/core';
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {Employee} from '../employees';
import {EmployeeService} from '../employees.service';
import {ActivatedRoute, Router} from '@angular/router';
import {SharedService} from '../../../../services/SharedService.service';
import {ConfirmationService, Message} from 'primeng/api';
import {MessageService} from 'primeng/components/common/messageservice';
import {NgbActiveModal, NgbModal, NgbModalOptions, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {AppLogComponent} from '../../../../components/app-log/app-log.component'
import {appConfig} from "../../../../app.config";
import {TranslateLoader, TranslateModule, TranslateService} from "@ngx-translate/core";
import {BrowserModule} from "@angular/platform-browser";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {CommonModule} from "@angular/common";
import {ConfirmDialogModule, DropdownModule, MessagesModule} from "primeng/primeng";
import {Http} from "@angular/http";
import {TranslateHttpLoader} from "@ngx-translate/http-loader";
import {UserPictureComponent} from "../../../../components/user-picture";
import {RecordDataComponent} from "../../../../components/record-data";
import {AppArcComponent} from "../../../../components/app-arc";
import {ItemsGroupsShowComponent} from "../../itemsGroups/itemsGroups-show/itemsGroups-show.component";
import {CurrenciesShowComponent} from "../../currencies/currencies-show/currencies-show.component";
import {BranchesShowComponent} from "../../branches/branches-show/branches-show.component";
import {CitiesShowComponent} from "../../cities/cities-show/cities-show.component";
import {OrganizationShowComponent} from "../../organization/organization-show/organization-show.component";
import {JobsShowComponent} from "../../jobs/jobs-show/jobs-show.component";
import {UserService} from "../../../../services";


@NgModule({
    imports: [CommonModule, FormsModule, DropdownModule,MessagesModule,
        ReactiveFormsModule, ConfirmDialogModule, TranslateModule.forChild()
    ],
    declarations: [
        EmployeesShowComponent
    ],
    entryComponents: [
        EmployeesShowComponent
    ],
    exports: [],
    providers: [SharedService, EmployeeService, MessageService, ConfirmationService],
    schemas: [NO_ERRORS_SCHEMA]
})

@Component({
    selector: 'app-employees-show',
    templateUrl: './employees-show.component.html',
    styleUrls: ['./employees-show.component.scss'],
    providers: [EmployeeService, ConfirmationService, MessageService]
})

export class EmployeesShowComponent implements OnInit, AfterViewInit {
    id: string;
    employee = new Employee();
    @Input() refShow;
    bank: any[] = [];
    // picture:string;x
    applog: AppLogComponent;
    parent_name: any;
    @Input() scrId;
    modalRef: NgbModalRef;
    parent:any;
    cities: any[] = [];
    jobs: any[] = [];
    users: any[] = [];
    orgs: any[] = [];
    branches: any[] = [];
    @Input() modelName;
    @Input() delId;
    @Input() oldData;
    @Input() newData;
    genVal = [{'val': 1, 'title': 'Male'}, {'val': 2, 'title': 'Female'}];
    empStatusVal = [{'val': 1, 'title': 'On the job'}, {'val': 2, 'title': 'Suspended'}];
    idTypeVal = [{'val': 1, 'title': 'Citizen '}, {'val': 2, 'title': 'Residence'}];
    empQlVal = [{'val': 1, 'title': 'None '}, {'val': 2, 'title': ' Primary'}, {'val': 3, 'title': ' Middle school'}, {'val': 4, 'title': ' High school'}, {'val': 5, 'title': ' Academic'}, {'val': 6, 'title': ' Master'}, {'val': 7, 'title': ' Ph.D.'}];
   cuntryTypeVal = [{'val': 1, 'title': 'sweetened '}, {'val': 2, 'title': 'international'}];

    form: FormGroup;
    private sub: any;
    msgs: Message[] = [];
    public imgUrl = appConfig.publicUrl;
    private _editButton: any;
    private _deleteButton: any;
    private _newButton: any;
    private _printButton: any;
    private _searchButton: any;

    constructor(private route: ActivatedRoute,
                private router: Router,
                private sharedservice: SharedService,
                private employeeService: EmployeeService,
                private modalService: NgbModal,
                public activeModal: NgbActiveModal,
                private userService:UserService,

                public translate: TranslateService,
                private confirmationService: ConfirmationService,
                private messageService: MessageService) {

        const userdata = JSON.parse(localStorage.getItem('currentUser'));

        if (userdata && userdata.lang) {
            this.translate.use(userdata.lang);
        }
        this.sharedservice.setTitle(this.route.snapshot.data.title);
        this.sharedservice.setButtons([
            {label: 'Delete', icon: 'fa-trash', btnClass: 'btn-danger', btnId: 'deleteButton'},
            {label: 'Edit', icon: 'fa-edit', btnClass: 'btn-warning', btnId: 'editButton'},
            {label: 'Print', icon: 'fa-print', btnClass: 'btn-skype', btnId: 'printButton'},
            {label: 'Add', icon: 'fa-plus', btnClass: 'btn-info', btnId: 'newButton'},
            {label: 'Query', icon: 'fa-search', btnClass: 'btn-primary', btnId: 'searchButton'},

        ]);
        this.sharedservice.setModelName('');

    }
    showParent(id: any){
        if(id) {
            const options: NgbModalOptions = {

                beforeDismiss: () => {
                    console.log("before dismiss");
                    //
                    return true;
                }
            };
            this.modalRef = this.modalService.open(BranchesShowComponent, options);
            this.modalRef.componentInstance.scrId = id;

            this.modalRef.result.then(() => {
                this.activeModal.dismiss('done');
            }, () => {
                console.log('Backdrop click')
            });
        }
    }
    showParentCity(id: any){
        if(id) {

            const options: NgbModalOptions = {

                beforeDismiss: () => {
                    console.log("before dismiss");
                    //
                    return true;
                }
            };
            this.modalRef = this.modalService.open(CitiesShowComponent, options);
            this.modalRef.componentInstance.scrId = id;

            this.modalRef.result.then(() => {
                this.activeModal.dismiss('done');
            }, () => {
                console.log('Backdrop click')
            });
        }
    }
    showParentOrg(id: any){
        if(id) {

            const options: NgbModalOptions = {

                beforeDismiss: () => {
                    console.log("before dismiss");
                    //
                    return true;
                }
            };
            this.modalRef = this.modalService.open(OrganizationShowComponent, options);
            this.modalRef.componentInstance.scrId = id;

            this.modalRef.result.then(() => {
                this.activeModal.dismiss('done');
            }, () => {
                console.log('Backdrop click')
            });
        }
    }
    showParentJob(id: any){
        if(id) {

            const options: NgbModalOptions = {

                beforeDismiss: () => {
                    console.log("before dismiss");
                    //
                    return true;
                }
            };
            this.modalRef = this.modalService.open(JobsShowComponent, options);
            this.modalRef.componentInstance.scrId = id;

            this.modalRef.result.then(() => {
                this.activeModal.dismiss('done');
            }, () => {
                console.log('Backdrop click')
            });
        }
    }
    recordData() {
        const options: NgbModalOptions = {

            beforeDismiss: () => {
                // this.changePicUrl();
                return true;
            }
        };
        const modalRef = this.modalService.open(RecordDataComponent, options);
        modalRef.componentInstance.refRec = this.employee;
        modalRef.componentInstance.rowId = '';

    }

    ngAfterViewInit() {
        this._editButton = document.getElementById('editButton');
        this._deleteButton = document.getElementById('deleteButton');
        this._newButton = document.getElementById('newButton');
        this._printButton = document.getElementById('printButton');
        this._searchButton = document.getElementById('searchButton');


        if (this._editButton) {
            this._editButton.onclick = ((e: any) => {
                e.preventDefault();
                this.router.navigate(['/employees/edit', this.id]);
            });
        }
        if (this._deleteButton) {

            this._deleteButton.onclick = ((e: any) => {
                e.preventDefault();
                this.deleteEmployee(this.employee);
            });
        }
        if (this._newButton) {

            this._newButton.onclick = ((e: any) => {
                e.preventDefault();
                this.router.navigate(['/employees']);
            });

        }
        if (this._searchButton) {
            this._searchButton.onclick = ((e: any) => {
                e.preventDefault();
                this.router.navigate(['/employees/search']);
            });

        }
    }

    ngOnInit() {


        this.userService.getAllUsers().subscribe(
            user =>{
                this.users = user['userslist'];
            }
        );
        this.employeeService.getAllCities().subscribe(
            cities => {
                this.cities = cities;
                console.log(this.cities);

            });
        this.employeeService.getAllBranches().subscribe(
            bra => {
                this.branches = bra['brancheslist'];
                console.log(this.branches);

            });
        this.employeeService.getAllJobs().subscribe(
            job => {
                this.jobs = job;
            });
        this.employeeService.getAllOrgs().subscribe(
            org => {
                this.orgs = org;
            });
        this.sub = this.route.params.subscribe(params => {
            this.id = params['id'];
            this.parent_name = params['employee_parent_group'];


        });

        this.form = new FormGroup({
            id: new FormControl({value: '', disabled: true}),
            name: new FormControl({value: '', disabled: true}),
            org_id: new FormControl({value: '', disabled: true}),
            branch_id: new FormControl({value: '', disabled: true}),
            user_id: new FormControl({value: '', disabled: true}),
            gender: new FormControl({value: '', disabled: true}),
            date_of_birth: new FormControl( {value: '', disabled: true}),
            address: new FormControl({value: '', disabled: true}),
            nat_id: new FormControl({value: '', disabled: true}),
            id_type: new FormControl({value: '', disabled: true}),
            id_number: new FormControl({value: '', disabled: true}),
            end_date: new FormControl({value: '', disabled: true}),
            mobile:new FormControl({value: '', disabled: true}),
            email: new FormControl({value: '', disabled: true}),
            job_id:new FormControl({value: '', disabled: true}),
            basic_salary:new FormControl({value: '', disabled: true}),
            allowances:new FormControl({value: '', disabled: true}),
            contract_start_date:new FormControl({value: '', disabled: true}),
            contract_end_date:new FormControl({value: '', disabled: true}),
            emp_status:new FormControl({value: '', disabled: true}),
            bank_account_num:new FormControl({value: '', disabled: true}),
            emp_qual:new FormControl({value: '', disabled: true}),
            emp_pic:new FormControl('')

        });

        if (this.id) {
            this.activeModal.dismiss('');
            this.oldData = false;
            this.newData = false;
            this.delId = false;
            localStorage.removeItem('filter');
            const msg = JSON.parse(localStorage.getItem('showMessages'));
            if (msg) {
                localStorage.removeItem('showMessages');
                this.msgs = msg;
                this.msgs = [];
            }
            this.employeeService.getById(this.id).subscribe(
                employee => {
                    this.id = employee.id;
                    this.employee = employee;
                    this.parent = employee.main_bank;
                    this.form.patchValue({
                        id: employee.id,
                        name: employee.name,
                        branch_id: employee.branch_id,
                        user_id: employee.user_id,
                        org_id: employee.org_id,
                        gender: employee.gender,
                        date_of_birth: employee.date_of_birth,
                        nat_id: employee.nat_id,
                        address: employee.address,
                        id_type:employee.id_type,
                        id_number:employee.id_number,
                        end_date:employee.end_date,
                        mobile:employee.mobile,
                        email: employee.email,
                        job_id: employee.job_id,
                        basic_salary: employee.basic_salary,
                        allowances: employee.allowance,
                        contract_start_date: employee.contract_start_date,
                        contract_end_date: employee.contract_end_date,
                        emp_status: employee.emp_status,
                        bank_account_num: employee.bank_account_num,
                        emp_qual: employee.academic_qualification,
                        emp_pic: employee.emp_pic,
                    });

                }, error => {
                    console.log(error);
                }
            );


        }
        if (this.delId) {
            this.oldData = false;
            this.newData = false;
            this.employeeService.getTrashedById(this.delId).subscribe(
                employee => {
                    this.id = employee.id;
                    this.employee = employee;
                    this.form.patchValue({
                        id: employee.id,
                        name: employee.name,
                        branch_id: employee.branch_id,
                        user_id: employee.user_id,
                        org_id: employee.org_id,
                        gender: employee.gender,
                        date_of_birth: employee.date_of_birth,
                        nat_id: employee.nat_id,
                        address: employee.address,
                        id_type:employee.id_type,
                        id_number:employee.id_number,
                        end_date:employee.end_date,
                        mobile:employee.mobile,
                        email: employee.email,
                        job_id: employee.job_id,
                        basic_salary: employee.basic_salary,
                        allowances: employee.allowance,
                        contract_start_date: employee.contract_start_date,
                        contract_end_date: employee.contract_end_date,
                        emp_status: employee.emp_status,
                        bank_account_num: employee.bank_account_num,
                        emp_qual: employee.academic_qualification,
                        emp_pic: employee.emp_pic,

                    });
                }, error => {
                    console.log(error);
                }
            );
        }

        if (this.oldData && this.newData) {
            this.employee = this.newData;
            this.refShow = this.oldData;
            this.form.patchValue({
                id: this.newData.id,
                branch_id: this.newData.branch_id,
                user_id: this.newData.user_id,
                org_id: this.newData.org_id,
                gender: this.newData.gender,
                date_of_birth: this.newData.date_of_birth,
                nat_id: this.newData.nat_id,
                address: this.newData.address,
                id_type:this.newData.id_type,
                id_number:this.newData.id_number,
                end_date:this.newData.end_date,
                mobile:this.newData.mobile,
                email: this.newData.email,
                job_id: this.newData.job_id,
                basic_salary: this.newData.basic_salary,
                allowances: this.newData.allowance,
                contract_start_date: this.newData.contract_start_date,
                contract_end_date: this.newData.contract_end_date,
                emp_status: this.newData.emp_status,
                bank_account_num: this.newData.bank_account_num,
                emp_qual: this.newData.academic_qualification,
                emp_pic: this.newData.emp_pic,

            });
        }
    }

    permissionAllow(button: string): boolean {
        let userRoles: any[] = [];
        const userdata = JSON.parse(localStorage.getItem('currentUser'));
        if (userdata) {
            userRoles = userdata.roles.description;
        }
        let role: string = '';
        switch (button) {
            case 'newButton': {
                role = 'create';
                break;
            }
            /*  case 'recordDataButton': {
                  role = 'recordData';
                  break;
              }*/
            case 'saveButton': {
                role = 'update';
                break;
            }
            case 'deleteButton': {
                role = 'delete';
                break;
            }
            case 'searchButton': {
                role = 'search';
                break;
            }
            case 'excelButton': {
                role = 'excel';
                break;
            }
            case 'printButton': {
                role = 'print';
                break;
            }
            case 'historyButton': {
                role = 'history';
                break;
            }
            case 'restoreButton': {
                role = 'restore';
                break;
            }
            case 'attachmentsButton': {
                role = 'attachments';
                break;
            }
            case 'rowinfo': {
                role = 'rowinfo';
                break;
            }

            default: {
                role = '';
                break;
            }
        }
        if (userRoles.indexOf('setting.employee.' + role) >= 0) {
            return true;
        }
        return false;
    }

    deleteEmployee(employee: Employee) {
        this.confirmationService.confirm({
            header: this.translate.instant('Confirm Delete'),
            message: this.translate.instant('Are you sure of delete ?'),
            icon: 'fa fa-trash',
            accept: () => {
                if (employee) {
                    this.employeeService.delete(employee.id).subscribe(
                        res => {
                            this.msgs = [];
                            this.msgs.push({
                                severity: 'success',
                                summary: '',
                                detail: this.translate.instant('Delete completed')
                            });
                            setTimeout(()=>{
                            this.router.navigate(['/employees']);
                        },1000);
                            localStorage.setItem('showMessages', JSON.stringify(this.msgs));
                            window.scroll(0,0);
                        }
                    );
                }
            }
        });
    }

    recoverEdit(employee: Employee) {
        this.confirmationService.confirm({
            header: this.translate.instant('Confirm Undo Edit'),
            message: this.translate.instant('Are you sure of undo ?. All data will be recover as seen in screen and any other editing will be dismiss'),
            icon: 'fa fa-undo',
            accept: () => {
                if (employee) {
                    this.employeeService.update(employee).subscribe(
                        res => {
                            this.msgs = [];
                            this.msgs.push({
                                severity: 'success',
                                summary: '',
                                detail: this.translate.instant('Data returned')
                            });
                            this.activeModal.close('done');
                            this.router.navigate(['/employees/show', employee.id]);
                        }
                    );
                }
            }
        });
    }

    undotrashed() {
        this.confirmationService.confirm({
            header: this.translate.instant('Confirm Undo Delete'),
            message: this.translate.instant('Are you sure about recover deleted item?'),
            icon: 'fa fa-undo',
            accept: () => {
                if (this.delId) {
                    this.employeeService.restoreTrashedById(this.delId).subscribe(
                        res => {
                            this.msgs = [];
                            this.msgs.push({
                                severity: 'success',
                                summary: '',
                                detail: this.translate.instant('Deleted employee recovered')
                            });
                            this.activeModal.dismiss('close click');
                            this.router.navigate(['/employees/list']);
                        }
                    );
                }
            }
        });
    }


  showattachement(row_id: string) {
    console.log(row_id)
    if (row_id) {
      const options: NgbModalOptions = {

        beforeDismiss: () => {
          // this.changePicUrl();
          return true;
        }
      };
      const modalRef = this.modalService.open(AppArcComponent, options);
      modalRef.componentInstance.rowId = row_id;
      modalRef.componentInstance.screenName = this.modelName;
    }
  }
  showHistory(row_id: string) {
    if (row_id) {
      const modalRef = this.modalService.open(AppLogComponent);
        modalRef.componentInstance.refShow = EmployeesShowComponent;
        modalRef.componentInstance.rowId = row_id;
    }
  }


}



// WEBPACK FOOTER //
// ./src/app/views/setting/employees/employees-show/employees-show.component.ts